import React, { useState } from "react";
import AdminLayout from "./AdminLayout";

const AdminChangePassword = () => {
  const [form, setForm] = useState({
    username: "admin",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleSubmit = () => {
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      alert("Please fill all fields");
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      alert("Passwords do not match ❌");
      return;
    }

    fetch("https://njinternational.ilakshyaerp.in/api/admin/change-password", {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    username: form.username,
    currentPassword: form.currentPassword,
    newPassword: form.newPassword,
  }),
})
  .then((res) => res.json())
  .then((data) => {
    if (!data.message) {
      throw new Error("Unexpected response");
    }

    alert(data.message);

    // reset form
    setForm({
      username: "admin",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });

    // LOGOUT
    localStorage.removeItem("adminToken");

    // REDIRECT
    window.location.href = "/admin/login";
  })
  .catch((err) => {
    console.log("ERROR:", err);
    alert(err.message || "Something went wrong");
  });
};

  // ✅ CORRECT PLACE FOR RETURN
  return (
    <AdminLayout>
      <div className="notice-page">
        <div className="notice-card">
          <h2>Change Password</h2>

          <input
            type="password"
            placeholder="Current Password"
            value={form.currentPassword}
            onChange={(e) =>
              setForm({ ...form, currentPassword: e.target.value })
            }
          />

          <input
            type="password"
            placeholder="New Password"
            value={form.newPassword}
            onChange={(e) =>
              setForm({ ...form, newPassword: e.target.value })
            }
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={form.confirmPassword}
            onChange={(e) =>
              setForm({ ...form, confirmPassword: e.target.value })
            }
          />

          <button onClick={handleSubmit}>
            Update Password
          </button>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminChangePassword;